import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listMemberships: [],
};

const membershipsSlice = createSlice({
  name: "memberships",
  initialState,
  reducers: {
    setListMemberships: (state, action) => {
      state.listMemberships = action.payload.listMemberships;
    },
    clearListMemberships: (state) => {
      state.listMemberships = [];
    },
  },
});

export const { setListMemberships, clearListMemberships } =
  membershipsSlice.actions;
export default membershipsSlice.reducer;
